import { render, staticRenderFns } from "./VRSliderCard.vue?vue&type=template&id=0948e0a7"
import script from "./VRSliderCard.vue?vue&type=script&lang=js"
export * from "./VRSliderCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports